import { IconButton, Avatar, Badge } from '@mui/material'
import GroupFillSVG from '@material-symbols/svg-600/sharp/group-fill.svg?react'
import { UPLOAD_FILETYPE } from '../../hooks/image-uploader/ImageUploader'
import { useState } from 'react'
import IconMaker from '../../components/IconMaker'

type Props = {
  icon: string
  onChange: (img: string)=> void
}
const UploadIcon: React.FC<Props> = ({icon, onChange}) => {
  const [display_img, setDisplayImg] = useState<string>(icon)
  const [edit_image, setEditImage] = useState<string>('')

  return <Badge
    overlap='circular'
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    badgeContent={<IconButton
      size='small'
      sx={{
        bgcolor: 'gray_b.main', boxShadow: '0 2px 4px rgba(0,0,0, 0.5)',
        '&:hover': { bgcolor: 'gray_b.light' }
      }}
      component='label'
    >
      <span className='material-icons-outlined'>add_photo_alternate</span>
      <input
        type='file'
        // nameを付与しない事でFormDataに情報を与えない
        hidden
        accept={UPLOAD_FILETYPE.join(',')}
        onClick={e=> {
          // クリック時にinputのvalueを空にすることで、同じファイルを選択してもonChangeが発火するようにする
          e.currentTarget.value = ''
        }}
        onChange={e=> {
          if (e.target.files) {
            const image = e.target.files[0]
            setEditImage(URL.createObjectURL(image))
          }
        }}
      />
    </IconButton>}
  >
    <Avatar
      src={display_img}
      sx={{ width: '84px', height: '84px' }}
    >
      {!icon && <GroupFillSVG style={{fill: 'white'}}/>}
    </Avatar>

    <IconMaker
      edit_image={edit_image}
      close={() => {
        if (edit_image.startsWith('blob:')) URL.revokeObjectURL(edit_image)
        setEditImage('')
      }}
      setCroppedImage={url=> {
        if (display_img.startsWith('blob:')) URL.revokeObjectURL(display_img)
        setDisplayImg(url)
        onChange(url)
        setEditImage('')
      }}
    />
  </Badge>
}
export default UploadIcon